import type {
  GameState,
  LockSeatOrderAction,
  ValidationResult,
} from "../types";
import { validateHostAction, validateSetupPhase } from "./common";

export function validateLockSeatOrder(
  state: GameState,
  action: LockSeatOrderAction,
): ValidationResult {
  const hostCheck = validateHostAction(
    state,
    action.actorPlayerId,
    "Only host can lock seats",
  );
  if (!hostCheck.valid) return hostCheck;

  const phaseCheck = validateSetupPhase(state);
  if (!phaseCheck.valid) return phaseCheck;

  if (state.seatLocked) {
    return { valid: false, error: "Seat order is already locked" };
  }

  return { valid: true };
}
